import { render, staticRenderFns } from "./AdvertsSwiper.vue?vue&type=template&id=5d931364&scoped=true&"
import script from "./AdvertsSwiper.vue?vue&type=script&lang=ts&"
export * from "./AdvertsSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertsSwiper.vue?vue&type=style&index=0&id=5d931364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d931364",
  null
  
)

export default component.exports